import Print from './print/print';
import React from 'react';

export default class PrintWrapper extends React.Component {
  render() {
    return this.props.listing ? (
      <div id="print-body">
        <Print listing={this.props.listing} entity={this.props.entity}/>
      </div>
    ) : null;
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/print-wrapper.js